import { AssetGroupDto } from "../dtos/assetGroupDto";
import { AssetGroup } from "../models/asset";
import ApiService from "../services/api";

export const fetchAssetGroups = async (): Promise<AssetGroup[]> => {
    const apiService = new ApiService();
    
    try {
        const response = await apiService.get<any>(`/fleet/groups?account_id=`);
        if (response.status === 200) {
            return response.data.map(AssetGroupDto);
        } else return [];
    } catch (error) {
        console.error(error);
        return [];
    }
}